"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _FocusableElement = require("@quixeltools/quixel-ui-library/dist/components/common/accessibility/FocusableElement");

var _FocusableElement2 = _interopRequireDefault(_FocusableElement);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var button = function button(mode, focused, selected, isDisabled) {
  return (0, _glamor.css)((0, _extends3.default)({
    background: "none",
    border: "none",
    font: "inherit",
    cursor: !isDisabled && "pointer",

    color: isDisabled ? _css.pallets.gray_text : _ramda2.default.or(_ramda2.default.or(_ramda2.default.and(_ramda2.default.or(selected, _ramda2.default.test(/white/, mode)), _css.pallets.white), _ramda2.default.and(_ramda2.default.test(/gray/, mode), _css.pallets.gray_text)), _css.pallets.blue_primary),

    textTransform: _ramda2.default.and(_ramda2.default.not(_ramda2.default.test(/small/, mode)), "uppercase"),
    textDecoration: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/underlined/, mode), "underline"), "none"),

    fontWeight: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "700"), "700"),

    letterSpacing: "-0.5px",
    padding: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "0.375em"), "0.75em"),

    transition: "box-shadow " + _css.time.fast + ", color " + _css.time.fast + " ease-in-out"

  }, !isDisabled && {
    ":hover": {
      color: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/white/, mode), _css.pallets.gray_text), _css.pallets.white)
    }
  }, {

    ":focus": {
      outline: "none"
    },

    boxShadow: focused && "0 0 10px 2px " + _css.pallets.blue_primary,

    "& .label": {
      borderBottom: selected && "2px solid " + _css.pallets.white,
      paddingBottom: (0, _css.unitRem)(0.3),
      pointerEvents: "none"
    },
    fontSize: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "1.5rem"), "2rem")
  }), (0, _css.maxWidth)(_css.breakpoints.super4k)({
    fontSize: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "1.125rem"), "1.175rem")
  }), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
    fontSize: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "0.9375rem"), "1.125rem")
  }), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
    fontSize: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "0.9375rem"), "1.125rem")
  }), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
    fontSize: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "0.9375rem"), "1rem")
  }), (0, _css.maxWidth)(_css.breakpoints.large)({
    fontSize: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "0.9375rem"), "0.9375rem")
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    fontSize: _ramda2.default.or(_ramda2.default.and(_ramda2.default.test(/small/, mode), "0.9375rem"), "0.95rem")
  }));
};

var subLabelCss = (0, _glamor.css)({
  textTransform: "uppercase",
  color: _css.pallets.red
});

var isValidTextButtonMode = _ramda2.default.flip(_ramda2.default.contains)(["normal", "underlined", "small-underline", "white", "small", "white-underlined", "small-gray", "small-gray-underlined", "small-white-underlined"]);
var TextButton = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(TextButton, _React$Component);

  function TextButton(props) {
    (0, _classCallCheck3.default)(this, TextButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextButton.__proto__ || (0, _getPrototypeOf2.default)(TextButton)).call(this, props));

    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);

    _this.state = { focused: false };
    return _this;
  }

  (0, _createClass3.default)(TextButton, [{
    key: "onFocus",
    value: function onFocus() {
      this.setState({ focused: true });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({ focused: false });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          mode = _props.mode,
          isDisabled = _props.isDisabled,
          label = _props.label,
          subLabel = _props.subLabel,
          selected = _props.selected,
          className = _props.className,
          to = _props.to,
          href = _props.href,
          onClick = _props.onClick,
          newWindow = _props.newWindow,
          restProps = (0, _objectWithoutProperties3.default)(_props, ["mode", "isDisabled", "label", "subLabel", "selected", "className", "to", "href", "onClick", "newWindow"]);
      var focused = this.state.focused;


      return _react2.default.createElement(
        "span",
        { className: (0, _glamor.css)(className) },
        _react2.default.createElement(
          _FocusableElement2.default,
          { onFocus: this.onFocus, onBlur: this.onBlur },
          to || href ? _react2.default.createElement(
            _reactRouter.Link,
            (0, _extends3.default)({
              to: to,
              href: href,
              className: (0, _glamor.css)(button(mode, focused, selected, isDisabled), className),
              onClick: onClick
            }, newWindow && { target: "_blank", rel: "noreferrer" }),
            _react2.default.createElement(
              "span",
              { className: "label" },
              label
            )
          ) : _react2.default.createElement(
            "button",
            (0, _extends3.default)({
              className: (0, _glamor.css)(button(mode, focused, selected, isDisabled), className),
              onClick: onClick
            }, restProps),
            _react2.default.createElement(
              "span",
              { className: "label" },
              label
            )
          )
        ),
        subLabel && _react2.default.createElement(
          "span",
          { className: subLabelCss },
          subLabel
        )
      );
    }
  }]);
  return TextButton;
}(_react2.default.Component), _class.defaultProps = {
  mode: "normal"
}, _temp);
exports.default = TextButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/TextButton.jsx
// module id = 2867
// module chunks = 0